export default __webpack_public_path__ + "gravit-designer.8a4db59e.png";